module.exports = "/../../dist/frontend/images/googleplay.svg?e908acaa9b0e86a1625b9d4ff465af7b";